import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

const CompanyStatus = ({ t = () => {}, isActive }) => {
  return (
    <div className="card-text row">
      <div className="col-12">
        <small>{t('common.status')}</small>
        <br />
        <strong>
          {t(isActive ? 'common.active' : 'common.deactivated', {
            context: 'female',
          })}
        </strong>
      </div>
    </div>
  );
};

CompanyStatus.propTypes = {
  t: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default translate()(CompanyStatus);



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/components/SubcompanyStatus.js